<template>
    <div class="columns is-mobile is-centered has-background-primary p-2" v-if="props.titoloVisibile==true">
        <h1 class="title is-4 has-text-white">DICO</h1>
    </div>

    <!--********** CAMPO DI RICERCA **********-->
    <div class="columns is-mobile is-centered" v-if="props.campoRicercaVisibile==true">
        <div class="column is-5">
            <div class="control">
                <input class="input is-primary" type="text" v-model="testoRicerca" placeholder="Cerca..." @keyup.enter="bCerca">
            </div>
        </div>
    </div>

    <!--********** TABELLA DICO **********-->
    <div class="blocco-scroll">
        <table class="table is-striped mx-auto">
            <thead>
                <tr>
                    <th class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaDico(-1)" v-if="props.bottoneAggiungiVisibile==true">
                            <span class="icon"><i class="fas fa-plus"></i></span>
                        </button>
                    </th>
                    <th v-if="mostraInfoSviluppo"></th>
                    <th class="has-text-centered" v-if="mostraInfoSviluppo">Id</th>
                    <th class="has-text-centered">Stato</th>
                    <th class="has-text-centered">Anno</th>
                    <th class="has-text-centered">Num.</th>
                    <th class="has-text-centered">Data</th>
                    <th v-if="props.lavoro==null">Lavoro</th>
                    <th>Oggetto</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(dc, index) in elencoDico" :key="leggiInfoDB(dc).id">
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaDico(leggiInfoDB(dc).id, leggiInfoDB(dc).idLavoro, leggiInfoDB(dc).idCliente)">
                            <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
                        </button>
                    </td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{index + 1}}</td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{leggiInfoDB(dc).id}}</td>
                    <td class="has-text-centered">
                        <ComponenteIcona :nome="dc.stato" />
                    </td>
                    <td class="has-text-centered">{{dataDaTimestamp(dc.data, 'anno')}}</td>
                    <td class="has-text-centered">{{dc.numero}}</td>
                    <td>{{dataDaTimestamp(dc.data, 'testo')}}</td>
                    <td v-if="props.lavoro==null"><a @click="emit('elementoSelezionato', {tipo: 'lavoro', idCliente: leggiInfoDB(dc).idCliente, idLavoro: leggiInfoDB(dc).idLavoro})">{{leggiInfoDB(dc).stringaLavoro}}</a></td>
                    <td>{{dc.oggetto}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="has-text-centered" colspan="2">{{stringaNumeroRecord}}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <!--********** MESSAGGIO MODALE **********-->
</template>

<script setup>
    import ComponenteIcona from "./ComponenteIcona.vue";
    import { defineProps, defineEmits, computed, ref } from "vue";
    import { dataDaTimestamp } from "./../code/utilita";
    import { mostraInfoSviluppo, getValorePerOrdinamento } from "@/code/utilita";
    import { dbClienti, leggiInfoDB } from "@/code/gestioneDB";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        cliente: {
            type: Number,
            default: null },
        lavoro: {
            type: Number,
            default: null },
        testoDaCercare: {
            type: String,
            default: null },
        bottoneAggiungiVisibile: {
            type: Boolean,
            default: false },
        campoRicercaVisibile: {
            type: Boolean,
            default: true },
        titoloVisibile: {
            type: Boolean,
            default: true }
    });
    // const emit = defineEmits(['dicoSelezionata', 'lavoroSelezionato', 'statoInterfacciaCambiato']);
    const emit = defineEmits(['elementoSelezionato', 'statoInterfacciaCambiato']);

    // VARIABILI DEL COMPONENTE
    const testoRicerca = ref(props.testoDaCercare);
    // const tempTestoRicerca = ref(testoRicerca.value);
    const stringaNumeroRecord = ref("");
    const elencoDico = computed(()=>{
        let tempElencoDico = [];
        if (props.lavoro==null) {
            if (props.cliente==null) {
                for(const cl in dbClienti.value){
                    for(const lv in  dbClienti.value[cl].lavori){
                        for(const dc in  dbClienti.value[cl].lavori[lv].dico){
                            tempElencoDico.push(dbClienti.value[cl].lavori[lv].dico[dc]);
                        }
                    }
                }
            } else {
                for(const lv in dbClienti.value[props.cliente].lavori){
                    for(const dc in dbClienti.value[props.cliente].lavori[lv].dico){
                        tempElencoDico.push(dbClienti.value[props.cliente].lavori[lv].dico[dc]);
                    }
                }
            }
        } else {
            const cl = props.cliente;
            const lv = props.lavoro;
            for(const dc in  dbClienti.value[cl].lavori[lv].dico){
                tempElencoDico.push(dbClienti.value[cl].lavori[lv].dico[dc]);
            }
        }
        ordinaElencoDico(tempElencoDico);
        filtraElencoElementi(tempElencoDico, props.testoDaCercare, ['anno', 'numero', 'oggetto', ['info', 'stringaLavoro']]);
        return tempElencoDico;
    });

    // SETUP DEL COMPONENTE

    // FUNZIONI DEL COMPONENTE
    function bCerca() {
        emit('statoInterfacciaCambiato', {testoRicercaDico: testoRicerca.value});
    }

    function bSelezionaDico(idDc, idLv, idCl) {
        let tempIdCl;
        let tempIdLv;
        tempIdCl = props.cliente==null ? idCl : props.cliente;
        tempIdLv = props.lavoro==null ? idLv : props.lavoro;
        emit('elementoSelezionato', {
            tipo: 'dico',
            idCliente: tempIdCl,
            idLavoro: tempIdLv,
            idDico: idDc
        });
    }

    // function ordinaElencoDico(elenco) {
    //     // Ordina elenco in ordine di anno e di numero
    //     elenco.sort( (a, b) => {
    //         return (b.numero-a.numero);
    //     });
    //     elenco.sort( (a, b) => {
    //         return (dataDaTimestamp(b.data, 'anno')-dataDaTimestamp(a.data, 'anno'));
    //     });
    //     return elenco;
    // }    

    function ordinaElencoDico(elenco) {
        // Ordina elenco in UN'UNICA PASSATA: prima per Anno (decrescente) e poi per Numero (decrescente)
        elenco.sort((a, b) => {
            
            // 1. Estrazione sicura della data (gestisce dati Caldi Firestore e Freddi Storage)
            const msA = getValorePerOrdinamento(a, 'data', false) || 0;
            const msB = getValorePerOrdinamento(b, 'data', false) || 0;

            // 2. Calcolo nativo e sicuro dell'anno (se non c'è data, va in fondo all'anno 0)
            const annoA = msA > 0 ? new Date(msA).getFullYear() : 0;
            const annoB = msB > 0 ? new Date(msB).getFullYear() : 0;

            // 3. Ordinamento Primario: per Anno (dal più recente al più vecchio)
            if (annoA !== annoB) {
                return annoB - annoA;
            }

            // 4. Ordinamento Secondario (a parità di anno): per Numero
            // Number() previene eventuali bug se i numeri fossero salvati come stringhe o fossero nulli
            const numA = Number(getValorePerOrdinamento(a, 'numero', false)) || 0;
            const numB = Number(getValorePerOrdinamento(b, 'numero', false)) || 0;

            return numB - numA; // (dal più grande al più piccolo)
        });

        return elenco;
    }

    function filtraElencoElementi(elencoEl, testo, campi) {
        // Filtra viewLeads cercando il testo nei campi indicati dall'array di stringhe 'campi'
        const tempStringaNumeroRecord = elencoEl.length;
        if ( testo ) {
            for (let i=0; i < elencoEl.length; i++) {
                const regexCerca = new RegExp(testo, 'i');
                let temp = null;
                let pos = -1;
                for (const cc in campi) {
                    if (pos == -1) {
                        // const tempContenuto = viewLeads.value[i][campi[cc]];
                        if ( Array.isArray(campi[cc]) ) {
                            if (campi[cc][0] === 'info' || campi[cc][0] === '_info') {
                                const infoDb = leggiInfoDB(elencoEl[i]) || {};
                                temp = infoDb[campi[cc][1]];
                            } else {
                                temp = elencoEl[i][campi[cc][0]] ? elencoEl[i][campi[cc][0]][campi[cc][1]] : undefined;
                            }
                        } else if ( campi[cc] == 'anno' ) {
                            temp = dataDaTimestamp(elencoEl[i].data, 'anno');
                        } else {
                            temp = elencoEl[i][campi[cc]];
                        }
                        pos = String(temp).search(regexCerca);
                    }
                }
                if (pos == -1) {
                    elencoEl.splice(i,1);
                    i--;
                }
            }
        }
        stringaNumeroRecord.value = elencoEl.length + " di " + tempStringaNumeroRecord;
    }
    
</script>

<style>
    .table th.prima-riga {
        border: none;
    }
    .table th.bordi-laterali {
        border-left: 1px solid #dbdbdb;
        border-right: 1px solid #dbdbdb;
        /* border-width: 0 0 1px; */
    }
</style>